import moment from 'moment'
import React from 'react'

const defaultTime = moment().subtract(1, 'minutes')

const useSnooze = ({
    durationMinutes = 30,
    updateDelay = 30000
} = {}) => {
    const [alarm, setAlarm] = React.useState(defaultTime)
    const [tick, setTick] = React.useState(0)

    const snooze = React.useCallback(() => {
        const alarm = moment().add(durationMinutes, 'minutes')
        setAlarm(alarm)
    }, [setAlarm, durationMinutes])

    const updateTime = React.useCallback(() => {
        setTick(tick + 1)
    }, [tick])

    React.useEffect(() => {
        const timeout = setTimeout(updateTime, updateDelay)
        return () => clearTimeout(timeout)
    }, [tick, updateDelay])

    const isActive = moment().isAfter(alarm)
    return {
        isActive,
        snooze
    }
}

export default useSnooze
